import React from 'react';
import Button from '../components/Button';
import Card from '../components/Card';
import CustomerCard from '../components/CustomerCard';
import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import SplitSection from '../components/SplitSection';
import StatsBox from '../components/StatsBox';
import customerData from '../data/customer-data';
import HeroImage from '../svg/HeroImage';
import SvgCharts from '../svg/SvgCharts';

export default () => (
  <Layout>
    <section className="pt-20 md:pt-40">
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-center lg:text-left lg:w-1/2">
          <h1 className="text-3xl lg:text-5xl xl:text-6xl font-bold leading-none">
            Oprogramowanie zorientowane do Twoich potrzeb
          </h1>
          <p className="text-xl lg:text-2xl mt-6 font-light">
            Software, który dostarcza wszystkie wymagane funkcje oraz spełnia najwyższe aktualne
            standardy
            <span style={{ fontWeight: 'bold' }}>
              &nbsp;(bezpieczeństwo, stabilność, użyteczność i funkcjonalność)&nbsp;
            </span>
            <br />
            to Software jaki tworzym.
          </p>
          <p className="text-xl mt-8 md:mt-12">
            //TODO:: Staramy się by nasze oprogramowanie Staramy się by nasze oprogramowanie Staramy
            się by nasze oprogramowanie Staramy się by nasze oprogramowanie
          </p>
          {/*  <Button size="lg">Get Started</Button> */}
          {/* </p> */}
          {/* <p className="mt-4 text-gray-600">Sed fermentum felis ut cursu</p> */}
        </div>
        <div className="lg:w-1/2">
          <HeroImage />
          {/*  to jest obrazek z ludkami ustawiajacymi design */}
        </div>
      </div>
    </section>
    <section id="ourOffert" className="py-20 lg:pb-40 lg:pt-48">
      <div className="container mx-auto text-center">
        <h2 className="text-4xl lg:text-6xl font-semibold">Nasza oferta</h2>
        <div className="flex flex-col sm:flex-row sm:-mx-3 mt-12">
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-4xl">Aplikacje</p>
              <p className="mt-5 text-justify">
                Wykonujemy za równo aplikacje mobilne (Android i iOS), dla przeglądarek (webowe)
                oraz programy desktopowe (Windows, MacOS, Linux). Tworzone przez nas aplikacje w
                pełni dostosowujemy do potrzeb i wymagań klienta. Zapewniamy w nich obecne standardy
                bezpieczeństwa i jakości. Projektowany design zapewnia intuicyjność i użyteczność
                będąc skierowanym na najnowsze trendy.
              </p>
            </Card>
          </div>
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-4xl">Systemy IT</p>
              <p className="mt-5 text-justify">
                Dostarczamy oprogramowanie dla chmur, dedykowanych serwerów oraz tworzymy pełne
                systemy informatyczne. Projektujemy dla nich architekturę, strukturę oraz wszystkie
                potrzebne komponenty. Nasze aplikacje serwerowe tworzymy z myślą o wymaganej
                wysokiej wydajności i bezpieczeństwie. Wykorzystujemy nowoczesne technologie i
                zachowujemy najwyższe standardy.
              </p>
            </Card>
          </div>
          <div className="flex-1 px-3">
            <Card className="mb-8">
              <p className="font-semibold text-4xl">Inne</p>
              <p className="mt-5 text-justify">
                Dostarczamy programy obsługujące i automatyzujące procesy firmowe. Programujemy
                mikrokontrolery, IoT, beacony i inne urządzenia zewnętrzne. Jeszcze podczas
                zbierania wymagań dotyczących projektu staramy się proponować odpowienie technologie
                i zewnętrzne rozwiązania, aby zapewnić najwyższą jakość dostarczonego produktu.
              </p>
            </Card>
          </div>
        </div>
      </div>
    </section>
    <br id="aboutUs" />
    <div className="lg:pt-24 container mx-auto text-center">
      <h2 className="text-4xl lg:text-6xl font-semibold">Jak Pracujemy</h2>
    </div>
    <SplitSection
      primarySlot={
        <div className="lg:pr-32 xl:pr-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Zbieranie wymagań i tworzenie specyfikacji
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Podczas pierwszych kontaktów z klientem kompletujemy wstępne wymagania i funkcjonalności
            jakie oprogramowanie ma dostarczać oraz jego założenia i cele. Konsultujemy z klientem
            możliwe metody wdrożenia, dystrybucji oraz późniejszego wykorzystania gotowego produktu
            w celu dostosowania wykorzystanych przez nas technologii. Staramy się całkowicie
            zrozumieć potrzeby klienta analizując podane wymagania, aby utworzone oprogramowanie
            zapewniało najwyższą jakość.
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <SplitSection
      reverseOrder
      primarySlot={
        <div className="lg:pl-32 xl:pl-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Wstępny szkic i proponowane rozwiązania
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Mając wstępną specyfikację, przygotowujemy &quot;szkic&quot; projektu. Zależnie od
            wymagań, szkicem może być design i layout aplikacji, opis użycia i działania
            poszczególnych funkcji (za równo po stronie użytkownika jak i aplikacji), architektura i
            struktura systemu. Dostosowując się do wymagań, staramy się określić architekturę oraz
            technologie tworzonego oprogramowania oraz proponujemy dodatkowe funkcje, rozwiązania
            czy też wykorzystanie zewnętrzyny produktów.
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <SplitSection
      primarySlot={
        <div className="lg:pr-32 xl:pr-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Implementacja i testowanie produktu
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Po akceptacji szkicu oraz ustalenia wszystkich wymagań produktu przystępujemy do jego
            rzeczywistej implementacji. Tworząc oprogramowanie wykorzystujemy najnowsze i stabilne
            technologie. Nasz kod pisany jest z zachowaniem szeroko przyjętych standardów i
            najlepszych praktyk. W miarę możliwości przedstawiamy wstępne działanie systemu, a w raz
            z nim gotowe funkcje. Każda pojedyncza funkcja jest testowana po to by finalny produkt
            działał bez zastrzeżeń.
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <SplitSection
      reverseOrder
      primarySlot={
        <div className="lg:pl-32 xl:pl-48">
          <h3 className="text-3xl font-semibold leading-tight">Wdrożenie i finalizacja projektu</h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Jeśli utworzony przez nas produkt został zaakceptowany, to przystępujemy do wdrożenia go
            u klienta. Wdrożeniem może być publikacja aplikacji w App Store, instalacja programu na
            serwerach lub komputerach oraz dostosowanie całego środowiska w celu zapewnienia
            poprawnego działania oprogramowania. W razie potrzeby utworzymy dodatkowe skrypty (np.
            instalacyjne) czy też napiszemy instrukcję użytkownika oraz konserwacji produktu. Po
            wdrożeniu zapewniamy czasową opiekę nad produktem. Podczas opieki nad produktem
            monitorujemy jego działanie i dostarczymy odpowiednie poprawki w razie nieprawidłowości
            w działaniu.
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    />
    <section id="stats" className="py-20 lg:pt-32">
      <div className="container mx-auto text-center">
        <LabelText className="text-gray-600">Our customers get results</LabelText>
        <div className="flex flex-col sm:flex-row mt-8 lg:px-24">
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+100%" secondaryText="Stats Information" />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+100%" secondaryText="Stats Information" />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+100%" secondaryText="Stats Information" />
          </div>
        </div>
      </div>
    </section>
    <section id="testimonials" className="py-20 lg:py-40">
      <div className="container mx-auto">
        <LabelText className="mb-8 text-gray-600 text-center">What customers are saying</LabelText>
        <div className="flex flex-col md:flex-row md:-mx-3">
          {customerData.map(customer => (
            <div key={customer.customerName} className="flex-1 px-3">
              <CustomerCard customer={customer} />
            </div>
          ))}
        </div>
      </div>
    </section>
    <section className="container mx-auto my-20 py-24 bg-gray-200 rounded-lg text-center">
      <h3 className="text-5xl font-semibold">Ready to grow your business?</h3>
      <p className="mt-8 text-xl font-light">
        Quis lectus nulla at volutpat diam ut. Enim lobortis scelerisque fermentum dui faucibus in.
      </p>
      <p className="mt-8">
        <Button size="xl">Get Started Now</Button>
      </p>
    </section>
  </Layout>
);
